import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import {
  getDriverList,
  updateDriverStatus,
  deleteDriver,
} from "../../../services/OrganisationServices/transportManagemetService.js";
import { getMethods } from "../../../services/utilityFunctions";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddDriverForm from "../../FormComponents/AddDriverForm";

import { useGlobalState } from "../../../services/hostelConst";

const TransportDriverTable = () => {
  const { _advanceFilterList, updateAdvanceFilterList } = useGlobalState();

  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getDriverList}
        tab1={"Transport"}
        tab2={"Drivers"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        updateStatus={updateDriverStatus}
        AddForm={AddDriverForm}
        deleteRow={deleteDriver}
      />
    </>
  );
};

export default TransportDriverTable;
